module.exports = __webpack_public_path__ + "static/media/kongqiyuanrebeng.515505e4.png";